import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    marginTop: theme.spacing(4),
    width: '100%',
  },
}))
